export class HttpController {

    constructor($scope, GeneralSettingsDao, JFrogEventBus, $timeout, XRayUIModelSaver, TOOLTIPS, $state, XRayUIState) {
        this.GeneralSettingsDao = GeneralSettingsDao;
        this.JFrogEventBus = JFrogEventBus;
        this.XRayUIState = XRayUIState
        this.$state = $state;
        this.httpsForm = null;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['mail']);
        this.$timeout = $timeout;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.https = {};
        this.TOOLTIP = TOOLTIPS.admin.mail;
        this.helpTooltips = {
            sslInput: 'This allows you to turn on/off HTTPS on the native Xray web server.\nOther actions such as changing the port or uploading the certificates should be done from the filesystem',
            sslCert: 'The full path of the certificate file on the web server.',
            sslKey: 'The full path of the key file on the web server.\n',
            port: 'Port is editable via `xray_config.yaml` file'
        }
        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;
        $scope.$parent.Settings.saveButtonText = 'Save';

        this.$timeout(() => {
            if (this.XRayUIState.getState('isSaas')) {
                //console.log('Saas');
                this.$state.go('home');
            }
        }, 500)

        this.getHttpConfig();
    }

    getHttpConfig() {

        this.GeneralSettingsDao.getHttpsInfo().$promise.then((response) => {
            this.https.useSSL = response.is_https;
            this.https.httpsPort = response.https_port;
            this.https.sslKey = response.key;
            this.https.sslCertificate = response.cert;
            this.sslValid = true;
            if (response.is_https) {
                this.sslValid = response.ssl_valid;
            }

        });
    }

    refresh() {

        this.GeneralSettingsDao.getHttpsInfo().$promise.then((response) => {
            this.https.httpsPort = response.https_port;
            this.https.sslKey = response.key;
            this.https.sslCertificate = response.cert;
        });
    }


    setHttpConfig() {

        let payload = {};

        payload.is_https = this.https.useSSL;
        payload.https_port = this.https.httpsPort;
        this.GeneralSettingsDao.updateHttpsInfo(payload).$promise.then((response) => {
            console.log('res is', response);
            if (response.status === 200) {
                this.$state.go('home');
            }
        });
    }

    save() {
        this.setHttpConfig()
    }

    cancel() {
        this.$state.go('home');
    }


    canSave() {
        return this.httpsForm.$valid;
    }

}


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/http_config/http_config.controller.js